module.exports = __webpack_public_path__ + "static/media/right-arrow-grey.bf1af2ee.svg";